import React, { useState } from "react";
import { FaArrowLeft, FaUser, FaFileAlt, FaPhone, FaMapMarkerAlt, FaGraduationCap, FaCar } from "react-icons/fa"; // Íconos
import { motion } from "framer-motion"; // Animaciones
import imganeNiñerasYALogo from "../../../../assets/imagen/logo-niñeras-ya.JPG"; // Logo de Niñeras YA


export default function NanaDetails({ nana, onSelect, onBack }) {
  const [showAlert, setShowAlert] = useState(false); // Estado para controlar la visibilidad del alert

  // Función para manejar el clic en el enlace del CV
  const handleCvClick = (e) => {
    e.preventDefault(); // Evita que el enlace se abra automáticamente
    setShowAlert(true); // Muestra el alert personalizado
  };

  // Función para confirmar la apertura del CV
  const handleConfirmCv = () => {
    setShowAlert(false); // Oculta el alert
    window.open(nana.cv, "_blank"); // Abre el enlace en una nueva pestaña
  };

  // Función para cancelar la apertura del CV
  const handleCancelCv = () => {
    setShowAlert(false); // Oculta el alert
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }} // Animación inicial
      animate={{ opacity: 1, y: 0 }} // Animación al aparecer
      transition={{ duration: 0.5 }} // Duración de la animación
    >
      {/* Botón para volver al listado */}
      <button
        onClick={onBack}
        className="text-blue-500 hover:text-blue-700 mb-4 flex items-center gap-2"
      >
        <FaArrowLeft /> {/* Ícono de flecha */}
        Volver al listado
      </button>

      {/* Contenedor de la imagen y detalles */}
      <div className="flex flex-col items-center space-y-4">
        {/* Imagen de la niñera */}
        <motion.div
          whileHover={{ scale: 1.05 }} // Efecto de escala al hacer hover
          className="w-32 h-32 rounded-full overflow-hidden border-2 border-gray-200"
        >
          <img
            src={nana.urlAvatar ? nana.urlAvatar : imganeNiñerasYALogo}
            alt={`Avatar de ${nana.nombre}`}
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Detalles de la niñera */}
        <div className="space-y-4 w-full">
          <p className="flex items-start gap-2">
            <FaUser className="text-blue-500 mt-1" /> {/* Ícono de usuario */}
            <div className="flex flex-col">
              <span><strong>Nombre:</strong> {nana.name}</span>
              <span><strong>Edad:</strong> {nana.age|| 'edad'}</span> {/* Asume que `age` es una propiedad de `nana` */}
              <span><strong>Estado Civil:</strong> {nana.maritalStatus || 'estado civil' } </span> {/* Asume que `maritalStatus` es una propiedad de `nana` */}
              <span><strong>Hijos:</strong> {nana.children}</span>

            </div>
          </p>
  <p className="flex items-center gap-2">
            <FaFileAlt className="text-blue-500" /> {/* Ícono de CV */}
            <a
              href={nana.cv}
              onClick={handleCvClick} // Manejador del clic
              className="text-blue-500 hover:text-blue-700 cursor-pointer"
            >
              Ver CV
            </a>
          </p>
          <p className="flex items-center gap-2">
            <FaPhone className="text-blue-500" /> {/* Ícono de teléfono */}
            <strong>Teléfono:</strong> {nana.phone}
          </p>
          <p className="flex items-center gap-2">
            <FaMapMarkerAlt className="text-blue-500" /> {/* Ícono de dirección */}
            <strong>Dirección:</strong> {nana.address}
          </p>
          <p className="flex items-center gap-2">
            <FaMapMarkerAlt className="text-blue-500" /> {/* Ícono de barrio */}
            <strong>Barrio:</strong> {nana.neighborhood}
          </p>
          <p className="flex items-center gap-2">
            <FaUser className="text-blue-500" /> {/* Ícono de disponibilidad */}
            <strong>Disponibilidad:</strong> {nana.availability}
          </p>
          <p className="flex items-center gap-2">
            <FaGraduationCap className="text-blue-500" /> {/* Ícono de estudios */}
            <strong>Nivel de Estudios:</strong> {nana.crossStudies}
          </p>
          <p className="flex items-center gap-2">
            <FaCar className="text-blue-500" /> {/* Ícono de movilidad */}
            <strong>Mobilidad:</strong> {nana.mobility}
          </p>
        </div>
      </div>

      {/* Botón para seleccionar la niñera */}
      <motion.button
        whileHover={{ scale: 1.05 }} // Efecto de escala al hacer hover
        whileTap={{ scale: 0.95 }} // Efecto de escala al hacer clic
        onClick={onSelect}
        className="mt-6 w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition-all"
      >
        Seleccionar Niñera
      </motion.button>

      {/* Alert personalizado */}
      {showAlert && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, y: -20 }} // Animación inicial
            animate={{ opacity: 1, y: 0 }} // Animación al aparecer
            transition={{ duration: 0.3 }} // Duración de la animación
            className="bg-white rounded-lg p-6 w-full max-w-md"
          >
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              ¿Abrir el CV?
            </h2>
            <p className="text-gray-600 mb-6">
              Estás a punto de abrir el CV de {nana.name}. ¿Estás seguro?
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={handleCancelCv}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-all"
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirmCv}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all"
              >
                Abrir CV
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </motion.div>
  );
}